import FixedConsultationForm from "./FixedConsultationForm";
import GridIMG from "./GridIMG";
import NavbarPC from "./NavbarPC";

const LandingHomeMO = () => {
  const basePath = `${process.env.PUBLIC_URL}/image/mo`;
  const imagePaths = Array.from(
    { length: 10 },
    (_, i) => `${basePath}/20250204_${i + 1}.jpg`
  );

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="landing-container">
      <NavbarPC /> {/* 모바일 네비게이션 바 */}
      <div className="image-container">
        {imagePaths.map((src, index) => (
          <div key={index} className="image-wrapper">
            <img
              id={`image-${index + 1}`}
              src={src}
              alt={`Image ${index + 1}`}
            />
            {index === 2 && <GridIMG />}
            {/* 두 번째 이미지 아래에 GridIMG 추가 */}
          </div>
        ))}
      </div>
      {/* <img
        src={`${process.env.PUBLIC_URL}/image/up.png`}
        alt="Scroll to Top"
        className="scroll-to-top"
        onClick={scrollToTop}
      /> */}
      <style jsx>{`
        .landing-container {
          margin-top: 90px; /* 네비게이션 바 높이 고려 */
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          overflow-x: hidden;
        }

        .image-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 5px;
        }

        img {
          width: 100%;
          height: auto;
          max-width: 600px; /* 모바일 최대 너비 제한 */
        }

        .scroll-to-top {
          width: 50px;
          height: 50px;
          position: fixed;
          bottom: 200px;
          right: 20px;
          cursor: pointer;
        }
        /* 🟢 800 이하에서 모바일 스타일 적용 */
        @media (max-width: 800px) {
          .image-container {
            gap: 3px;
          }

          img {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default LandingHomeMO;
